import { render, staticRenderFns } from "./ApproveProject.vue?vue&type=template&id=00ff8801&scoped=true"
import script from "./ApproveProject.vue?vue&type=script&lang=js"
export * from "./ApproveProject.vue?vue&type=script&lang=js"
import style0 from "./ApproveProject.vue?vue&type=style&index=0&id=00ff8801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ff8801",
  null
  
)

export default component.exports